export default function lottie() {
  const lottie = require('lottie-web')

  document.addEventListener('DOMContentLoaded', function() {
    const elements = document.querySelectorAll('[data-src]')

    elements.forEach(element => {
      const animInstance = lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: element.getAttribute('data-src'),
      })

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              animInstance.play()
              observer.unobserve(entry.target)
            }
          })
        },
        {
          threshold: 0.5,
        }
      )

      observer.observe(element)
    })
  })
}
